import type { ReactNode } from 'react'
import entStyles from '../../styles/enterprise/EnterpriseOperationalUx.module.scss'
import styles from '../../styles/pages/Reports.module.css'

type SectionProps = {
  layerLabel?: string
  title?: string
  subtitle?: ReactNode
  children: ReactNode
  testId?: string
  className?: string
}

/**
 * Reports content section on the light PageLayout surface.
 * Uses a light panel + dark text (WCAG AA). Nested blue KPI metrics
 * (`entStyles.postureMetric`) keep white-on-blue contrast.
 */
export default function ReportsEnterpriseSection({
  layerLabel,
  title,
  subtitle,
  children,
  testId,
  className,
}: SectionProps) {
  return (
    <section
      className={`${entStyles.layer} ${className || ''}`.trim()}
      data-testid={testId}
      data-reports-panel="light"
    >
      {layerLabel ? <p className={entStyles.layerLabel}>{layerLabel}</p> : null}
      <div className={styles.reportsLightPanel}>
        {title ? <h2 className={styles.reportsLightTitle}>{title}</h2> : null}
        {subtitle ? <p className={styles.reportsLightSubtitle}>{subtitle}</p> : null}
        {children}
      </div>
    </section>
  )
}

/**
 * Light content card for charts / key findings lists on Reports.
 * Title uses dark text; do not put white-text-only children here.
 */
export function ReportsEnterpriseCard({
  title,
  children,
  className,
}: {
  title?: string
  children: ReactNode
  className?: string
}) {
  return (
    <article
      className={`${styles.reportsLightCard} ${className || ''}`.trim()}
      data-reports-panel="light"
    >
      {title ? <h3 className={styles.reportsLightCardTitle}>{title}</h3> : null}
      {children}
    </article>
  )
}
